<main class="qra-shell">
    <upp-guest-access *ngIf="view.View === 'GUEST'"></upp-guest-access>
    <upp-guest-home *ngIf="view.View === 'PLACE'"></upp-guest-home>
    <router-outlet></router-outlet>
</main>
